// Default camera positions and settings
export const DEFAULT_CAMERA_POSITION: [number, number, number] = [0, 0.8, 2.2];
export const DEFAULT_CAMERA_TARGET: [number, number, number] = [0, 0.6, 0];
export const DEFAULT_CAMERA_FOV = 50;
export const DEFAULT_CAMERA_NEAR = 0.1;
export const DEFAULT_CAMERA_FAR = 1000;

// Camera positions for different animation modes
export const ANIMATION_MODE_CAMERAS = {
  step_by_step: {
    position: [0, 0.8, 2.2] as [number, number, number],
    target: [0, 0.6, 0] as [number, number, number],
  },
  exploded_view: {
    position: [0, 1.8, 4.0] as [number, number, number],
    target: [0, 0, 0] as [number, number, number],
  },
  auto: {
    position: [0, 1.5, 3.5] as [number, number, number],
    target: [0, 0.5, 0] as [number, number, number],
  },
};

// Default background color
export const DEFAULT_BACKGROUND_COLOR = '#fafafb';

// Lighting defaults
export const DEFAULT_AMBIENT_LIGHT_INTENSITY = 2;
export const DEFAULT_DIRECTIONAL_LIGHTS = [
  { position: [5, 5, 5] as [number, number, number], intensity: 3, castShadow: true },
  { position: [-3, 2, -2] as [number, number, number], intensity: 2 },
  { position: [0, 5, 0] as [number, number, number], intensity: 1.5 },
];

// Environment preset for Drei
export const DEFAULT_ENVIRONMENT_PRESET = 'city';

// Self-hosted HDRI environment map (served from /public).
// Replaces drei's default preset CDN (raw.githack.com), which is a community
// proxy with rate limits and downtime. Passing `files` to <Environment>
// bypasses the preset CDN entirely and loads from our own origin.
// Source: pmndrs/drei-assets @456060a /hdri/potsdamer_platz_1k.hdr (the 'city' preset).
export const DEFAULT_ENVIRONMENT_FILES = '/hdri/potsdamer_platz_1k.hdr';
